import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import * as Icons from 'lucide-react';

const ServiceCard = ({ service }) => {
  const IconComponent = Icons[service.icon.split('-').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1)
  ).join('')] || Icons.Box;

  return (
    <Card className="bg-slate-900/50 border-cyan-500/20 hover:border-cyan-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-cyan-500/20 group backdrop-blur-sm">
      <CardHeader>
        <div className="w-14 h-14 bg-gradient-to-br from-cyan-400/20 to-blue-600/20 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
          <IconComponent className="text-cyan-400" size={28} />
        </div>
        <CardTitle className="text-white text-xl">{service.title}</CardTitle>
        <CardDescription className="text-gray-400">
          {service.description}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-wrap gap-2">
          {service.features.map((feature, index) => (
            <Badge
              key={index}
              variant="outline"
              className="bg-cyan-500/10 text-cyan-400 border-cyan-500/30 hover:bg-cyan-500/20 transition-colors duration-300"
            >
              {feature}
            </Badge>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default ServiceCard;
